import { useQuery } from "convex/react";
import { api } from "../../../../backend/convex/_generated/api";
import { useParams } from "react-router-dom";

export function useOrganization() {
  const { orgSlug } = useParams<{ orgSlug: string }>();
  
  const organization = useQuery(api.organizations.getBySlug, 
    orgSlug ? { slug: orgSlug } : "skip"
  );

  const isAdmin = organization?.role === "admin" || organization?.role === "owner";
  const isOwner = organization?.role === "owner";

  return {
    organization,
    orgSlug,
    isAdmin,
    isOwner,
    isLoading: organization === undefined,
  };
}

